import partnerClient from "../partnerClient";

export const fetchPartnerEnrolment = async () => {
  const { data } = await partnerClient.get("/enrolment");
  return data?.data ?? data;
};

export const fetchStaffOnboarding = async () => {
  const { data } = await partnerClient.get("/enrolment/onboarding");
  return data?.data ?? data;
};

export const uploadStaffOnboardingDocument = async (kind, file) => {
  const body = new FormData();
  body.append("file", file);
  const { data } = await partnerClient.post(`/enrolment/documents?kind=${kind}`, body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data?.data ?? data;
};

export const completeStaffOnboarding = async (payload) => {
  const { data } = await partnerClient.post("/enrolment/complete", payload);
  return data?.data ?? data;
};
